
import React, { useState, useEffect } from 'react'
import Flex from 'components/Flex'
import { Form, Modal } from 'antd'
import Label from 'components/Label/Label'
import Avatar from 'components/Avatar'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import AntdSelect from 'components/Form/Select'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import Emptystates from 'components/icons/Emptystates.svg'
import Party from 'components/Images/party.png'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import Input from 'components/Input/input'
import {
  Content,
  DisplayPad,
  Learn,
  MailHeading,
  MailSubHeading,
  StyledSelectDiv,
  StyledInput,
  SplitFlex,
  Otp,
  OTPHeading,
  InputGroup,
  OTPButton,
  OTPMessage,
  RowPadding,
  Span,
  SpanBold,
  StyledB,
  StyledInputDiv,
} from 'modules/ManageProfile/Components/PhoneModel/style'
const ChangePhoneNum = ({
  phoneModel,
  phoneOTP,
  phoneVerify,
  setPhoneModel,
  setPhoneOTP,
  onPhoneEntered,
  enteredPhone,
  setPhoneVerify,
  SendOtp,
  checkOtp,
  getUserInfo,
  setenteredPhone,
  userData,
}) => {
  const [countryCode, setCountryCode] = useState('+91')
  const [phoneForm] = Form.useForm()

  const [errmsg, setErrmsg] = useState('')
  const [otpSMS, setOtpSMS] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  })

  useEffect(() => {
    getUserInfo()
  }, [])

  useEffect(() => {
    if (otpSMS?.otp1 && otpSMS?.otp2 && otpSMS?.otp3 && otpSMS?.otp4) {
      otpSMSCheck()
    }
  }, [otpSMS])

  const onCountryCodeChange = data => {
    setCountryCode(data)
  }

  const clickEventSMS = (position, e) => {
    if (position !== 'last' && e.target.value) {
      document.getElementById(position).focus()
    }
    if (position === 'sec') {
      setOtpSMS({ ...otpSMS, otp1: e.target.value })
    } else if (position === 'third') {
      setOtpSMS({ ...otpSMS, otp2: e.target.value })
    } else if (position === 'fourth') {
      setOtpSMS({ ...otpSMS, otp3: e.target.value })
    } else {
      setOtpSMS({ ...otpSMS, otp4: e.target.value })
    }
  }

  const otpSMSCheck = async () => {
    let otpNum = `${otpSMS?.otp1}${otpSMS?.otp2}${otpSMS?.otp3}${otpSMS?.otp4}`

    let payLoad = {
      otp: otpNum,
      newPhoneNumber: enteredPhone,
    }
    let respo = await checkOtp(payLoad)

    if (respo?.data?.message?.success === true) {
      setPhoneVerify(true)
      setPhoneOTP(false)
      setErrmsg('')
    } else {
      respo?.data?.message?.message
        ? setErrmsg(respo?.data?.message?.message)
        : setErrmsg('Incorrect OTP')
    }
  }

  const handlePhoneVerifyCancel = () => {
    setPhoneVerify(false)
    getUserInfo()
  }

  const CountryCode = [
    {
      id: '1',
      value: '+91',
    },
  ]

  const sendPhoneOTP = () => {
    if (enteredPhone === userData?.phone_number) {
      ErrorMessage(
        'Entered Phone Number Should not be same as Current Phone Number'
      )
      phoneForm.resetFields()
    } else {
      let payLoad = {
        newPhone: enteredPhone,
        newEmail: '',
      }
      SendOtp(payLoad)
      setPhoneModel(false)
      setPhoneOTP(true)
      phoneForm.resetFields()
    }
  }
  const handlePhoneCancel = () => {
    setenteredPhone()
    setPhoneModel(false)
  }
  const handlePhoneOTPCancel = () => {
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
    setenteredPhone()
    setPhoneOTP(false)
  }

  const resendOtp = async () => {
    let payLoad = {
      newPhone: enteredPhone,
      newEmail: '',
    }
    let otpresp = await SendOtp(payLoad);
    if (otpresp === true) {
      SuccessMessage('OTP Sent Successfully')
    } else {
      ErrorMessage(otpresp)
    }
  }
  const onChnageSendOtpSMS = async () => {
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })

    setErrmsg('')
  }

  return (
    <>
      <Modal
        width={'585px'}
        open={phoneModel}
        footer={null}
        onCancel={handlePhoneCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt="" />
            </Flex>
            <MailHeading>Update Your Phone Number</MailHeading>
            <MailSubHeading>
              You have to <b>Verify</b> your phone number to Login further *
            </MailSubHeading>
          </Content>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={sendPhoneOTP}
            form={phoneForm}
            id={'phoneForm'}
            layout="vertical"
          >
            <Label>Phone Number *</Label>
            <Control>
              <StyledSelectDiv>
                <AntdSelect
                  width="100%"
                  OptionData={CountryCode}
                  nameParam="value"
                  bordered={false}
                  placeholder="+91"
                  onChange={onCountryCodeChange}
                  value={countryCode}
                  disabled={true}
                />
              </StyledSelectDiv>
              <StyledInputDiv>
                <StyledInput
                  width="100%"
                  type="number"
                  placeholder="Eg: 1010101010"
                  name="Phone"
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter phone number!',
                    },
                    {
                      min: 10,
                      max: 10,
                      message: 'Please enter valid phone number',
                    },
                  ]}
                  onChange={onPhoneEntered}
                />
              </StyledInputDiv>
            </Control>
            <DisplayPad>
              <Button.Primary
                htmlType="submit"
                text={'Send Verification Code'}
                width={'100%'}
                padding={'10px'}
              />
            </DisplayPad>
          </Form>
          <MailSubHeading>
            You will receive an OTP to your phone number to verify your phone
            number.{' '}
          </MailSubHeading>

          <SplitFlex row spaceBetween alignCenter>
            <Flex flexStart>
              <Learn href={'http://pluginlive.com'} target="_blank">
                Learn More
              </Learn>
            </Flex>
            <MailSubHeading>*Terms and condition applied</MailSubHeading>
          </SplitFlex>
        </RowPadding>
      </Modal>
      <Modal
        width={'585px'}
        open={phoneOTP}
        footer={null}
        onFinish={sendPhoneOTP}
        onCancel={handlePhoneOTPCancel}
        afterClose={handlePhoneOTPCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt="" />
            </Flex>
            <MailHeading>Verify your Phone Number </MailHeading>
          </Content>

          <MailSubHeading>
            We will send you a 4-digit ‘One Time Password’ to your phone number
            . Please verify it to proceed further.
          </MailSubHeading>
          <DisplayPad>
            <MailSubHeading>
              A verification code will be sent to
              <StyledB>{enteredPhone}</StyledB>
            </MailSubHeading>
          </DisplayPad>
          <Otp alignCenter column>
            <OTPHeading>Enter the OTP</OTPHeading>
            <InputGroup>
              <Input
                placeholder="0"
                width="50px"
                type="number"
                padding="19px"
                id="1st"
                maxLength={1}
                onChange={e => clickEventSMS('sec', e)}
                value={otpSMS?.otp1}
              />
              <Input
                placeholder="0"
                type="number"
                id="sec"
                width="50px"
                padding="19px"
                maxLength={1}
                onChange={e => clickEventSMS('third', e)}
                value={otpSMS?.otp2}
              />
              <Input
                placeholder="0"
                width="50px"
                type="number"
                padding="19px"
                id="third"
                maxLength={1}
                onChange={e => clickEventSMS('fourth', e)}
                value={otpSMS?.otp3}
              />
              <Input
                placeholder="0"
                id="fourth"
                width="50px"
                padding="19px"
                type="number"
                maxLength={1}
                onChange={e => clickEventSMS('last', e)}
                value={otpSMS?.otp4}
              />
            </InputGroup>
            <Span>{errmsg}</Span>
            <OTPButton onClick={() => onChnageSendOtpSMS()}>
              Didn’t receive? &nbsp;
              <SpanBold onClick={resendOtp}>Resend OTP</SpanBold>
            </OTPButton>
            {!otpSMS?.otp4 && (
              <OTPMessage>
                <div>
                  <CheckCircleIcon />
                </div>
                <div>OTP Sent Successfully.</div>
              </OTPMessage>
            )}
          </Otp>
        </RowPadding>
      </Modal>

      <Modal
        width={'585px'}
        open={phoneVerify}
        footer={null}
        onCancel={handlePhoneVerifyCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <Avatar src={Party} size={50} shape={'square'} />
            </Flex>
            <MailHeading>Verified Successfully</MailHeading>
            <MailSubHeading>
              Your mobile number verified successfully.
            </MailSubHeading>
          </Content>
        </RowPadding>
      </Modal>
    </>
  )
}

export default ChangePhoneNum
